import { render, staticRenderFns } from "./amara-loader.vue?vue&type=template&id=451552a4&scoped=true"
import script from "./amara-loader.vue?vue&type=script&lang=js"
export * from "./amara-loader.vue?vue&type=script&lang=js"
import style0 from "./amara-loader.vue?vue&type=style&index=0&id=451552a4&prod&lang=scss&scoped=true"
import style1 from "./amara-loader.vue?vue&type=style&index=1&id=451552a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451552a4",
  null
  
)

export default component.exports